var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Foundation page-default-config"},[_c('div',{staticClass:"content"},_vm._l((_vm.contents),function(item,index){return _c('div',{key:index,staticClass:"cell",style:(_vm.$global.moduleShowAnimation(index))},[_c('img',{attrs:{"src":item,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }